import { useNotification } from '../../context/notificationProvider';
import logo from '../../styles/img/reports/pikkoNotification.svg';
import { MdClose } from 'react-icons/md';

export const AppNotification = () => {
    const { notificationIsOpen, notificationType,
            notificationTitle, notificationDescription, closeNotification } = useNotification();

    const getNotificationColor = () => {
        switch (notificationType) {
            case 'error':
                return 'bg-red-500';
            case 'warning':
                return 'bg-yellow-500';
            case 'success':
                return 'bg-green-500';
            default:
                return 'bg-[#2D2D2D]';
       }
    }

    if (!notificationIsOpen) return null;

    return (
        <div className={`fixed bottom-4 left-4 right-4 ${getNotificationColor()} rounded-2xl p-4 z-[1000000] animate-slide-up-notification shadow-lg max-w-[95%] mx-auto`}>
            <img src={logo} alt="logo" className='w-20 h-20 absolute -top-[46px] left-0' />
            <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                    {notificationTitle && (
                        <h3 className="text-white font-medium geomanistMedium text-xl mb-1 leading-tight">
                            {notificationTitle}
                        </h3>
                    )}
                    {notificationDescription && (
                        <p className="text-white/90 geomanistRegular text-xl leading-relaxed">
                            {notificationDescription}
                        </p>
                    )}
                </div>

                <button
                    type="button"
                    onClick={closeNotification}
                    className="text-white transition-colors duration-200 p-1rounded-full flex-shrink-0"
                    aria-label="Fermer la notification"
                >
                   <MdClose className='text-2xl text-white fill-white' />
                </button>
            </div>

            <style jsx>{`
                @keyframes slide-up-notification {
                    from {
                        opacity: 0;
                        transform: translateY(100%);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-slide-up-notification {
                    animation: slide-up-notification 0.3s ease-out;
                }
            `}</style>
        </div>
    );
};

export default AppNotification;